import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardMetricCardComponent } from '../../../../../../shared/components/dashboard-metric-card/dashboard-metric-card.component';

@Component({
  selector: 'app-sad-summary',
  standalone: true,
  imports: [CommonModule, DashboardMetricCardComponent],
  templateUrl: './sad-summary.component.html',
  styleUrls: ['./sad-summary.component.css'],
})
export class SadSummaryComponent {
  @Input() rustAlertCount: number = 0;
  @Input() phomaAlertCount: number = 0;
  @Input() isLoadingRustAlert: boolean = true;
  @Input() isLoadingPhomaAlert: boolean = true;
}
